import type { DeepPartial } from '@luna/utils-ts';

import type { ContactDataManagementFeatureConfig } from './type';

export const contactDataManagement: DeepPartial<ContactDataManagementFeatureConfig> = {
    changeNotEditableContactMessengerTopicId: '1',
};
